<script>
    import {
      Card,
      CardBody,
    } from "sveltestrap";

</script>

<Card>
    <CardBody>
        <div class="mb-4 h1 card-title">Datasets Summary</div>
        <div>
          <p class="card-text">
            Korean Legal Artificial Intelligence Datasets(KLAID) is a dataset for the development of Korean legal artificial intelligence technology. This time we offer 1 task, which is legal judgment prediction(LJP). <a href="https://huggingface.co/datasets/lawcompany/KLAID">DATASET CARD</a>
          </p>
        </div>
      </CardBody>
</Card>